import { render, staticRenderFns } from "./teachers-send.vue?vue&type=template&id=7ecdc49c&"
import script from "./teachers-send.vue?vue&type=script&lang=js&"
export * from "./teachers-send.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports